// Format helpers for Brazilian locale
 
export function formatDate(iso, withTime = false) {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    if (!withTime) return `${dd}/${mm}/${yyyy}`;
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
  } catch {
    return '-';
  }
}
 
export function formatDateTime(iso) {
  return formatDate(iso, true);
}
 
export function formatRelative(iso) {
  if (!iso) return '-';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'agora';
  if (diff < 3600) return `${Math.floor(diff / 60)} min atrás`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h atrás`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} dias atrás`;
  return formatDate(iso);
}
 
export function formatCurrency(v) {
  if (v === null || v === undefined) return 'R$ 0,00';
  return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
 
export function maskCNPJ(v) {
  if (!v) return '';
  const s = String(v).replace(/\D/g, '').slice(0, 14);
  return s
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
}
 
export function maskCPF(v) {
  if (!v) return '';
  const s = String(v).replace(/\D/g, '').slice(0, 11);
  return s
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}
 
export function maskDocument(v) {
  if (!v) return '';
  const s = String(v).replace(/\D/g, '');
  if (s.length <= 11) return maskCPF(s);
  return maskCNPJ(s);
}
 
export function maskPhone(v) {
  if (!v) return '';
  const s = String(v).replace(/\D/g, '').slice(0, 11);
  if (s.length <= 10) return s.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').trim();
  return s.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').trim();
}
 
export function maskCEP(v) {
  if (!v) return '';
  const s = String(v).replace(/\D/g, '').slice(0, 8);
  return s.replace(/(\d{5})(\d{0,3})/, '$1-$2').replace(/-$/, '');
}
 
export function onlyDigits(v) {
  return String(v || '').replace(/\D/g, '');
}
 
export function fileSize(bytes) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(i ? 1 : 0)} ${units[i]}`;
}

